import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateTimeUtil } from '@kutil';

@Component({
  selector: 'kp-modal-workbook',
  templateUrl: './modal-workbook.component.html',
  styleUrls: ['./modal-workbook.component.scss'],
})
export class ModalWorkbookComponent implements OnInit {
  @Input() timestamp: string;
  @Output() closeClicked = new EventEmitter();

  date: string;

  ngOnInit() {
    if (this.timestamp) {
      this.date = DateTimeUtil.formatDate(new Date(this.timestamp), 'MMMM d, y');
    }
  }
}
